export const categories = [
  {
    id: 1,
    name: 'Обувь',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    name: 'Худи / Свитеры',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 3,
    name: 'Футболки',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 4,
    name: 'Куртки',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 5,
    name: 'Брюки / Шорты',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 6,
    name: 'Головные уборы',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 7,
    name: 'Комплекты',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 8,
    name: 'Нижнее бельё',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 9,
    name: 'Джерси',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 10,
    name: 'Аксессуары',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 11,
    name: 'Сумки',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 12,
    name: 'Ремни',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 13,
    name: 'Парфюмерия',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 14,
    name: 'Разное',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';